import * as React from "react";
const TableSortingLineIcon = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  width: "1em",
  height: "1em",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "m15.063 12 .937.938-4 4-4-4L8.938 12 12 15.063 15.063 12Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("mask", {
  id: "table-sorting-line_svg__a",
  width: 8,
  height: 5,
  x: 8,
  y: 12,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "m15.063 12 .937.938-4 4-4-4L8.938 12 12 15.063 15.063 12Z",
  clipRule: "evenodd"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#table-sorting-line_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-24-22h72v72h-72z"
})), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M8.938 11 8 10.062l4-4 4 4-.938.938L12 7.937 8.937 11Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("mask", {
  id: "table-sorting-line_svg__b",
  width: 8,
  height: 5,
  x: 8,
  y: 6,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M8.938 11 8 10.062l4-4 4 4-.938.938L12 7.937 8.937 11Z",
  clipRule: "evenodd"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#table-sorting-line_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M48 45h-72v-72h72z"
})));
export default TableSortingLineIcon;